<template>
	<div class="sub-detail-item flex flex-grow" :style="{'width': full ? '100%' : '50%'}">
		<label class="sub-detail-item-label flex-end-main">{{label}}</label>
		<div class="sub-detail-item-content flex-grow">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			label: String,
			
			full: Boolean
		}
	};
</script>